export default "__VITE_ASSET__CNPAsQfA__"